export default "__VITE_ASSET__mMolU2r___"